// KidLanding — Jul 2026 (Randy). Magic link / QR entry point: /kid/{token}.
// Stores the kid session and bounces to the kid home. No account needed.
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function KidLanding() {
  const { token } = useParams();
  const nav = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) { setError(true); return; }
    axios.get(`${API}/kid/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => {
        // Feb 28 2026 v5 (Randy pt-kid-portal-persistent-session) —
        // ALSO carry the token forward in the URL as `?k=<tok>` (not
        // just localStorage). This is the only way to survive iOS
        // 16.4+ PWA storage partitioning: when Ivy adds "/kid-home?k="
        // to home screen, iOS captures the URL AS-IS (with the token)
        // and re-opens at that URL — so the fresh partitioned
        // localStorage is populated from the URL on cold launch. Same
        // trust model as the QR (bearer key; revocable via "Reset all
        // links & sessions").
        localStorage.setItem("mysilo_kid_token", token);
        nav(`/kid-home?k=${encodeURIComponent(token)}`, { replace: true });
      })
      .catch(() => setError(true));
  }, [token, nav]);

  return (
    <div className="min-h-[100dvh] bg-[#FDFCF8] flex items-center justify-center p-6">
      <div className="text-center max-w-sm" data-testid="kid-landing">
        {error ? (
          <>
            <div className="text-5xl mb-4">🔒</div>
            <h1 className="font-serif-display text-2xl text-[#1C1B1A] mb-2">This link doesn't work anymore</h1>
            <p className="text-sm text-[#6B6A68]">Ask a parent to make you a new one from the Household panel.</p>
          </>
        ) : (
          <>
            <div className="text-5xl mb-4 animate-bounce">👋</div>
            <h1 className="font-serif-display text-2xl text-[#1C1B1A]">One second…</h1>
          </>
        )}
      </div>
    </div>
  );
}
